'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { useDecisions } from '../../hooks';
import { hasConsentGroup } from '../utils';
export const useSquadupModalScript = () => {
  const $ = _c(6);
  const isOneTrust = useDecisions("onetrust");
  const scriptLoaded = useRef(false);
  const scriptEl = useRef(null);
  const scriptLoadingPromise = useRef(null);
  let t0;
  if ($[0] !== isOneTrust) {
    t0 = () => {
      if (scriptLoaded.current) {
        return Promise.resolve();
      }
      if (scriptLoadingPromise.current) {
        return scriptLoadingPromise.current;
      }
      if (isOneTrust && !hasConsentGroup({
        group: "C0003",
        groups: window.OnetrustActiveGroups
      })) {
        return Promise.reject(new Error("No consent for C0003 category"));
      }
      scriptLoadingPromise.current = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://embed.squadup.com/main-v2.min.js";
        script.async = true;
        script.onload = () => {
          scriptLoaded.current = true;
          scriptEl.current = script;
          scriptLoadingPromise.current = null;
          resolve();
        };
        script.onerror = () => {
          scriptLoadingPromise.current = null;
          reject(new Error("Failed to load SquadUp script"));
        };
        document.body.appendChild(script);
      });
      return scriptLoadingPromise.current;
    };
    $[0] = isOneTrust;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const loadSquadupScript = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      if (scriptEl.current) {
        document.body.removeChild(scriptEl.current);
        scriptEl.current = null;
        scriptLoaded.current = false;
      }
      scriptLoadingPromise.current = null;
    };
    t2 = [];
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== loadSquadupScript) {
    t3 = {
      loadSquadupScript,
      isScriptLoaded: scriptLoaded
    };
    $[4] = loadSquadupScript;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};